import { Flex } from '@chakra-ui/react';
import { Radio } from '@morressier/alembic';
import { ChangeEventHandler } from 'react';
import { Control, Controller } from 'react-hook-form';

type IValue = string | boolean;

interface RadioGroupProps {
  name: string;
  control: Control<any>;
  options: {
    value: IValue;
    children: React.ReactNode;
  }[];
  defaultValue?: IValue;
  required?: boolean;
  gap?: number;
  isEditingAllowed?: boolean;
  onChange?: (value: IValue) => void;
}

export const RadioGroup = (props: RadioGroupProps) => {
  const { isEditingAllowed = true, onChange } = props;
  return (
    <Controller
      name={props.name}
      control={props.control}
      defaultValue={props.defaultValue ?? null}
      rules={{ required: props.required ? 'This field is required.' : false }}
      render={({ field: { onChange: fieldOnChange, value } }) => (
        <Flex flexDirection="column" gap={props.gap ?? 0}>
          {props.options.map(option => (
            <Radio
              name={props.name}
              value={option.value}
              onChange={
                (() => {
                  fieldOnChange(option.value);
                  onChange?.(option.value);
                }) as ChangeEventHandler<HTMLInputElement>
              }
              checked={value === option.value}
              ariaLabel={`${props.name}-${option.value}`}
              id={`${props.name}-${option.value}`}
              // @ts-ignore
              disabled={!isEditingAllowed}
            >
              {option.children}
            </Radio>
          ))}
        </Flex>
      )}
    />
  );
};
